// removed by extract-text-webpack-plugin
module.exports = {"ripple":"theme__ripple___1qF4x","rippleWrapper":"theme__rippleWrapper___2EkVm","rippleRestarting":"theme__rippleRestarting___n78rE","rippleActive":"theme__rippleActive___3nVZh"};


//////////////////
// WEBPACK FOOTER
// ../documittu/packages/template/~/react-toolbox/lib/ripple/theme.scss
// module id = 436
// module chunks = 0